import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

const StyleGroundingResults = styled.div``
export const StyleGroundingResult = styled.div`
  padding: 2rem 3rem 3rem;
  border-radius: 3px;
  box-shadow: 0px -1px 2px rgb(0 0 0 / 15%), 2px 2px 2px rgb(0 0 0 / 25%);
  margin: 5px 0 30px 0;
  display: block;
  background-color: white;

  > p:first-child {
    text-align: end;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .alert {
    max-width: 100% !important;
  }

  .title-result {
    color: ${({ theme }) => theme.colors.successColor};
    text-align: center;
  }

  .document-form {
    margin-top: 3rem;
    margin-bottom: 8rem;
    button {
      width: inherit;
      min-width: 100px;
    }

    .download-btn {
      width: 104%;
    }

    @media (max-width: ${gridBreakPoints.sm}) {
      .download-btn {
        transform: translateX(-12px);
      }
    }
  }

  .email-input,
  .ground-another-vin {
    .send-button {
      width: inherit;
    }
    display: flex;
    > label {
      transform: translateY(4px);
      font-weight: bold;
    }
    .search-option-scan-btn {
      min-width: fit-content;
      background-color: ${({ theme }) => {
        return theme.carousel.buttonColor
      }};
      border: 1px solid lightgray;
      margin: 0 0 0 -1px;
      display: flex;
      align-items: center;

      * {
        cursor: pointer;
      }

      svg {
        margin: 0 5px;
        fill: ${({ theme }) => {
          return theme.carousel.buttonTextColor
        }};
        height: 1.8rem;
        width: 1.8rem;
        flex-shrink: 0;
      }

      label {
        line-height: normal;
        margin: 0;
        color: ${({ theme }) => {
          return theme.carousel.buttonTextColor
        }};
      }
      &:hover {
        background-color: black;
        label {
          color: white;
        }
        svg {
          fill: white;
        }
      }
    }
  }
`
export default StyleGroundingResults
